function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useRef } from 'react';
import { useRefCallback } from '../../../callback/ref-callback';
import { getDefaultElementSize } from '../../co-dom';
import { useRefGetter } from '../../use';
import { useElementSize } from './useElementSize';
var NO_MATCH = 'NO_MATCH';
export function useElementResponsive(element, enable, breakpoints, onBreakpointChange) {
  var range = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var lastElementSize = useRef(range ? getDefaultElementSize() : undefined);
  var breakpointsRefGetter = useRefGetter(breakpoints);
  var onBreakpointChangeCallback = useRefCallback(onBreakpointChange);
  useElementSize(element, enable, function (size) {
    var bkList = breakpointsRefGetter();

    if (bkList.length === 0) {
      return;
    }

    var lastSize = lastElementSize.current || size;

    if (!lastElementSize.current) {
      lastElementSize.current = size;
      return;
    }

    var matched = matchBreakpoints(bkList, size.width, lastSize.width);

    if (matched != null) {
      onBreakpointChangeCallback(matched);
    }

    lastElementSize.current = size;
  });
}
export function matchBreakpointRange(bkList, width) {
  var res = {
    name: NO_MATCH,
    point: -1
  };
  bkList.sort(function (a, b) {
    return a.point - b.point;
  });
  bkList.some(function (bk, i) {
    var matched = width >= bk.point && (i + 1 === bkList.length || width < bkList[i + 1].point);

    if (matched) {
      res = bk;
    }

    return matched;
  });
  return res;
}
export function matchBreakpoints(bkList, width, lastWidth) {
  var currentMatched = matchBreakpointRange(bkList, width);
  var lastMatched = matchBreakpointRange(bkList, lastWidth);

  if (currentMatched.name === lastMatched.name) {
    return null;
  }

  if (currentMatched.name === lastMatched.name) {
    return null;
  }

  var matched = currentMatched.name === NO_MATCH ? lastMatched : currentMatched;
  return _objectSpread(_objectSpread({}, matched), {}, {
    width: width,
    lastWidth: lastWidth,
    reverse: lastWidth > width
  });
}